const usePasswordValidation = (password) => {
  const checkedPassword = password || '';
  const validLength = checkedPassword.length >= 12 && checkedPassword.length <= 128;
  return {
    valid: validLength,
    length: validLength,
  };
};

export default usePasswordValidation;
